import Phaser from 'phaser';
import { DebugLog } from './DebugLog';

export function transitionTo(scene: Phaser.Scene, targetScene: string, data?: object) {
  DebugLog.info('SceneTransition', `${scene.scene.key} -> ${targetScene}`, data);
  scene.cameras.main.resetFX();
  scene.scene.start(targetScene, data);
}
